

import {sizerScreens} from './SizerUI/SizerConfig/RouteConfig';

export const interviewScreens = sizerScreens;


    


// WEBPACK FOOTER //
// ./src/SizerScreens.js